const { io } = require('./ioHandler');
const { state } = require('./state');

const { buildName } = require('./nameBuilder');
const { initMatchmaking, showStartBotGameUI } = require('./matchmaking');

const { reactRender } = require('./reactRender');
const { leaderboard } = require('./leaderboard');

const { initCustomGameLobby } = require('./customGameLobby');
const { initGame } = require('./client');

const { getCookie, setCookie, getStartingName, getAllowCookies } = require('./cookieUtils');

const { incrementCounterValue, observeHistogramMetric } = require('./frontendStats');

function startLobby() {
  constructTutorialHTML();
}

function returnToLobby() {
  reactRender.nothing();
  io.emit('backToLobby');
  constructSignedInHTML(state.name);
}

function signInAnonUser(name, onComplete) {
  io.on('loggedIn', (msg) => {
    setCookie('traitorsId', msg.userId, 365);
    state.name = name;
    state.userId = msg.userId;
    state.signedIn = true;
    onComplete();
  });
  
  // look for save id
  let userId = undefined; 
  if (getAllowCookies())
    userId = getCookie('traitorsId');

  io.emit('signInOrCreateAccount', {
    name,
    userId: userId ? userId : undefined,
    shouldSaveInDB: getAllowCookies(),
  });
}

function joinCustomGame(text) {

  if (text.length > 0) {
    io.emit('joinCustomGame', { gameId: formatCustomGameNameText(text) });
    transitionToCustomGame();
  } else
    reactRender.showAlert("Enter a join code");
}

function formatCustomGameNameText(text) {
  return text.trim().toLowerCase().replace("/join/", "").replace("/", "").replace(":", "");
}

function showJoinOrCreateCustomGame() {
  reactRender.custom(
    returnToLobby,
    () => { 
      console.log("createCustomGame");
      io.emit('createCustomGame', true); transitionToCustomGame();
    },
    (text) => { joinCustomGame(text); }
  )
}

function getTutorialReturnFunction() {
  return state.signedIn ? 
    returnToLobby :
    () => constructSignupLobbyHTML();
}

function constructTutorialHTML() {
  reactRender.tutorial( 
    () => {
      incrementCounterValue("initial_tutorial_response", "yes");
      reactRender.nothing(startLobby);
      initGame(true, getTutorialReturnFunction(), null, null);
    }, 
    () => {
      incrementCounterValue("initial_tutorial_response", "no");
      constructSignupLobbyHTML();
    },
  );
}

function callbackWithNewName(text, functionAfter) {

  if (state.signedIn) {
    io.emit('changeName', { name: text }); 
    state.name = text;
    functionAfter();
  } else {
    signInAnonUser(text, functionAfter);
  }

}

function constructSignupLobbyHTML() {

  let prefilledName = getStartingName();
  reactRender.main(prefilledName || buildName(), 
    true,
    (text) => callbackWithNewName(text, () => {transitionToMatchmaking(false);}), 
    (text) => callbackWithNewName(text, showJoinOrCreateCustomGame),
    (text) => callbackWithNewName(text, transitionToBotGame),
    () => { reactRender.nothing(startLobby); initGame(true, getTutorialReturnFunction(), null, null); }, // tutorial
    "Start game vs bots >",
    (text) => callbackWithNewName(text, () => leaderboard.showLeaderboard(returnToLobby)),
    (text) => callbackWithNewName(text, () => {transitionToMatchmaking(true);}), 
  );
}

// TODO make this page a little different
// I don't know if we should allow users to change name
function constructSignedInHTML() {

  reactRender.main(state.name, 
    true,
    (text) => { callbackWithNewName(text, () => transitionToMatchmaking(false)) },
    (text) => { callbackWithNewName(text, () => showJoinOrCreateCustomGame())},
    (text) => { callbackWithNewName(text, () => transitionToBotGame())},
    (text) => { callbackWithNewName(text, () => { reactRender.nothing(startLobby); initGame(true, getTutorialReturnFunction(), null, null); })}, // tutorial
    "Start game vs bots >",
    (text) => { callbackWithNewName(text, () => leaderboard.showLeaderboard(returnToLobby)) },
    (text) => { callbackWithNewName(text, () => transitionToMatchmaking(true)) },
  );
}

function endLobby() {
  io.off('loggedIn');
  io.off('userCreated');

  reactRender.nothing();
}

function transitionToMatchmaking(ranked = false) {
  endLobby();
  io.emit('findGame', { ranked: ranked });
  initMatchmaking(returnToLobby, ranked);
}

function transitionToBotGame() {
  endLobby();
  showStartBotGameUI(returnToLobby);
}

function returnToCustomGameLobby(gameId) {
  
    io.emit('joinCustomGame', { gameId: gameId, createIfDoesntExist: true });

    io.on('failedCustomGameLobby', params => {

      io.off('failedCustomGameLobby');
      io.off('joinedCustomGameLobby');
      io.off('foundCustomGameWithMatchingId');

      returnToLobby();

      if (params && params.msg)
        reactRender.showAlert(params.msg);
    });

    io.on('joinedCustomGameLobby', params => {

      endLobby();
      io.off('failedCustomGameLobby');
      io.off('joinedCustomGameLobby');
      io.off('foundCustomGameWithMatchingId');
      initCustomGameLobby(params.isAdmin, params.gameId, returnToLobby, () => initGame(false, returnToLobby, () => returnToCustomGameLobby(params.gameId), "Return to lobby"));
    });
    
    io.on('foundCustomGameWithMatchingId', params => {
      endLobby();
      io.off('failedCustomGameLobby');
      io.off('joinedCustomGameLobby');
      io.off('foundCustomGameWithMatchingId');

      const returnFunction = function() {
        if (params.gameId && params.gameId.length == 4)
          returnToCustomGameLobby(params.gameId);
        else {
          returnToLobby();
          transitionToMatchmaking();
        }
      }

      initGame(false, returnToLobby, returnFunction, gameId && gameId.length == 4 ? "Return to lobby" : undefined);
    });
}

function transitionToCustomGame() {
  
  io.on('failedCustomGameLobby', params => {
    io.off('failedCustomGameLobby');
    io.off('joinedCustomGameLobby');
    io.off('foundCustomGameWithMatchingId');
    if (params && params.msg)
      reactRender.showAlert(params.msg);
  });

  io.on('joinedCustomGameLobby', params => {
    endLobby();
    io.off('failedCustomGameLobby');
    io.off('joinedCustomGameLobby');
    io.off('foundCustomGameWithMatchingId');
    initCustomGameLobby(params.isAdmin, params.gameId, returnToLobby, () => initGame(false, returnToLobby, () => returnToCustomGameLobby(params.gameId), "Return to lobby"));
  });

  io.on('foundCustomGameWithMatchingId', params => {
    endLobby();
    io.off('failedCustomGameLobby');
    io.off('joinedCustomGameLobby');
    io.off('foundCustomGameWithMatchingId');
    initGame(false, returnToLobby, () => returnToCustomGameLobby(params.gameId), "Return to lobby");
  });
}

module.exports = { startLobby, endLobby, constructSignupLobbyHTML, signInAnonUser, transitionToMatchmaking, returnToLobby, returnToCustomGameLobby, constructSignedInHTML };
